module.exports = __webpack_public_path__ + "img/avatar_1.fb3731dc.png";